import { getCurrentProductCode, isPluginProduct } from '@common/api/productContext';
import type { CSSProperties } from 'react';
import bizsidekickWordmarkSrc from '../../../public/brand/bizsidekick-wordmark.svg';
import bizsidekickWordmarkInverseSrc from '../../../public/brand/bizsidekick-wordmark-inverse.svg';
import bustlyWordmarkSrc from '../../../public/brand/bustly-wordmark.svg';

export interface ProductBrandLogoProps {
    size?: string;
    style?: CSSProperties;
    className?: string;
    tone?: 'regular' | 'inverse';
    coreLogoSrc?: string;
    coreLogoAlt?: string;
}

const BIZSIDEKICK_WORDMARK_SRC = bizsidekickWordmarkSrc;
const BIZSIDEKICK_WORDMARK_INVERSE_SRC = bizsidekickWordmarkInverseSrc;
const BUSTLY_WORDMARK_SRC = bustlyWordmarkSrc;

const ProductBrandLogo = ({
    size,
    style,
    className,
    tone = 'regular',
    coreLogoSrc,
    coreLogoAlt = 'Bustly Logo',
}: ProductBrandLogoProps) => {
    if (!isPluginProduct(getCurrentProductCode())) {
        return (
            <img
                src={coreLogoSrc || BUSTLY_WORDMARK_SRC}
                alt={coreLogoAlt}
                className={className}
                style={{ ...(size ? { height: size } : {}), ...style }}
            />
        );
    }

    return (
        <img
            src={tone === 'inverse' ? BIZSIDEKICK_WORDMARK_INVERSE_SRC : BIZSIDEKICK_WORDMARK_SRC}
            alt="BizSidekick"
            className={className}
            style={{ ...(size ? { height: size } : {}), ...style }}
        />
    );
};

export default ProductBrandLogo;
